export const environment = {
  production: false,
  apiBaseUrl: 'https://staging-api.lagesio.com',
  supportedLangs: ['en', 'ro'] as const,
  defaultLang: 'en' as const,
  logSignalRClosures: true,
};